import IconSvg from 'src/assets/icons/IconSvg';
import clsx from 'clsx';

interface Props {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
}

const SearchRaffleInput = ({ value, onChange, className, placeholder = 'Search raffles' }: Props) => {
  return (
    <div className={clsx('relative w-full xl:w-[480px]', className)}>
      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-grayscale-400">
        <IconSvg icon="searchM" />
      </div>

      <input
        type="text"
        className={clsx(
          'py-2 w-full h-10 text-base rounded-lg bg-grayscale-900',
          'text-grayscale-400 placeholder:text-grayscale-400',
          'px-11 outline-none focus:ring-1 focus:ring-grayscale-700',
        )}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
      />

      {value ? (
        <button
          onClick={() => onChange('')}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-grayscale-500 hover:text-grayscale-300"
        >
          <IconSvg icon="closeS" />
        </button>
      ) : (
        <div className="absolute right-3 top-1/2 text-lg font-medium rounded-md -translate-y-1/2 bg-brand-black text-brand-granite px-[9px] w-[26px] h-[26px] flex items-center justify-center">
          /
        </div>
      )}
    </div>
  );
};

export default SearchRaffleInput;
